import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, ParamMap, Params, Router} from '@angular/router';
import {SigmanRestService} from "../../rest-services/sigman.rest.service";

@Component({
    selector: 'app-signature-redirect',
    templateUrl: './signature-redirect.component.html',
    styleUrls: ['./signature-redirect.component.scss']
})
export class SignatureRedirectComponent implements OnInit {

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private sigmanRestService: SigmanRestService) {
    }

    ngOnInit(): void {
        // Récupération de l'identifiant de la session de signature
        let transactionId = this.activatedRoute.snapshot.paramMap.get('transactionId');

        // Récupération des queryParams envoyés par le partenaire
        let queryParamMap: ParamMap = this.activatedRoute.snapshot.queryParamMap;

        this.sigmanRestService.finalisation(transactionId, queryParamMap).subscribe(
                () => {
                    this.router.navigate(['fin_de_session'], { queryParams: { actionId: 'signatureProcuration', sigResult: 'OK' },  queryParamsHandling: "merge" });
                },
                (error) => {
                    console.log('error:', error);
                });
    }

}
